<template>
  <div class="gift">
    <div class="sendPopup-banji">
      <span class="sendPopup-banjiHd">当前班级：</span>
      <div class="sendPopup-banjiBd" @mouseout="zenpingxiangqinShowDetal=false">
        <p
          class="sendPopup-banjiC"
          @mousemove="zenpingxiangqinShowDetal=true"
        >{{curGiftList[zenpingxiangqinDetailIndex].MyClassName}}</p>
        <ul
          class="sendPopup-banjiUl"
          @mousemove="zenpingxiangqinShowDetal=true"
          v-show="zenpingxiangqinShowDetal"
        >
          <li
            v-for="(v,i) in curGiftList"
            @click="changeZpClass(i,v.ExamdaMyClassId)"
            :key="v.MyClassId"
          >{{v.MyClassName}}</li>
        </ul>
      </div>
    </div>
    <div class="sendPopup-tableBox">
      <table class="sendPopup-table" cellpadding="0" cellspacing="0" width="100%">
        <thead>
          <tr>
            <th width="12.5%">赠品</th>
            <th width="42.5%">详情</th>
            <th width="12.5%">版本</th>
            <th width="32.5%">寄送时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v,i) in bookList.JiaoCai" :key="i">
            <td v-if="i==0" :rowspan="bookList.JiaoCai.length">教材</td>
            <td>{{v.BookName}}</td>
            <td>{{v.ShowYear}}版</td>
            <td>{{v.BookSendTime}}</td>
          </tr>
          <tr v-for="(v,i) in bookList.JiaoFu" :key="i + 100">
            <td v-if="i==0" :rowspan="bookList.JiaoFu.length">教辅</td>
            <td>{{v.BookName}}</td>
            <td>{{v.ShowYear}}版</td>
            <td>{{v.BookSendTime}}</td>
          </tr>
          <tr v-for="(v,i) in bookList.TiKu" :key="i + 200">
            <td v-if="i==0" :rowspan="bookList.TiKu.length">题库</td>
            <td>{{v.BookName}}</td>
            <td>{{v.ShowYear}}</td>
            <td>{{v.BookSendTime}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getBook } from "../../../../../lib/request.js";
export default {
  name: "Gift",
  props: {
    curGiftList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      zenpingxiangqinShowDetal: false,
      zenpingxiangqinDetailIndex: 0,
      bookList: {},
    };
  },
  mounted() {
    this.changeZpClass(0, this.curGiftList[0].ExamdaMyClassId);
  },
  methods: {
    changeZpClass(i, myClassId) {
      getBook({ myClassId: myClassId }, (res) => {
        this.bookList = res.Result;
      });
      this.zenpingxiangqinDetailIndex = i;
      this.zenpingxiangqinShowDetal = false;
    },
  },
};
</script>


<style lang="scss" scoped>
.send-infoPopup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1001;
}
.sendPopup-cont {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 800px;
  padding: 20px;
  margin-top: -400px;
  margin-left: -420px;
  background: url(https://img2.233.com/wx/union/pc/pupage/img/send-popupbg.jpg)
    no-repeat 0 0 #fff;
  border-radius: 10px;
}
.sendPopup-h3 {
  font-size: 24px;
  color: #e95047;
  font-weight: 900;
  position: relative;
}
.sendPopup-h3:before {
  content: "";
  position: absolute;
  top: 50%;
  left: -20px;
  width: 3px;
  height: 22px;
  margin-top: -11px;
  background-color: #e95047;
}
.sendPopup-banji {
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  border-radius: 30px;
  background-image: linear-gradient(90deg, #f5f5f5, #fff);
  font-size: 16px;
  color: #888;
  white-space: nowrap;
  margin-top: 10px;
}
.sendPopup-banjiBd {
  display: inline-block;
  *display: inline;
  zoom: 1;
  position: relative;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  color: #333;
  z-index: 2;
}
.sendPopup-banjiC {
  position: relative;
  padding-right: 20px;
  cursor: pointer;
}
.sendPopup-banjiC:before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  width: 10px;
  height: 6px;
  margin-top: -1px;
  background: url(https://img2.233.com/wx/union/pc/pupage/img/send-ico.png)
    no-repeat -40px 0;
}
.sendPopup-banjiUl {
  position: absolute;
  top: 40px;
  left: 0;
  min-width: 100%;
  background-color: #f5f5f5;
  padding-bottom: 6px;
  max-height: 500px;
  overflow-y: auto;
}
.sendPopup-banjiUl > li {
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 20px 0 10px;
}
.sendPopup-banjiUl > li:hover {
  color: #e13b29;
}
.sendPopup-tableBox {
  width: 100%;
  max-height: 420px;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 26px #dddddd;
  text-align: center;
  margin-top: 10px;
}
.sendPopup-table thead {
  height: 44px;
  line-height: 44px;
  background-color: #ed483f;
  font-size: 18px;
  color: #fff;
  font-weight: 900;
}
.sendPopup-table tbody td {
  line-height: 22px;
  padding: 10px 10px;
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  font-size: 15px;
  color: #666;
}
.sendPopup-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 20px;
  height: 20px;
  background: url(https://img2.233.com/wx/union/pc/pupage/img/send-ico.png) 0 0;
  transition: 0.4s;
}
</style>